module.exports = __webpack_public_path__ + "static/affective-neuroscience-b917c5996e88b0b4f88eee73ff7a0016.jpg";